import { render } from "./TextHint.vue?vue&type=template&id=616ae706&scoped=true"
import script from "./TextHint.vue?vue&type=script&lang=ts"
export * from "./TextHint.vue?vue&type=script&lang=ts"

import "./TextHint.vue?vue&type=style&index=0&id=616ae706&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-616ae706"

export default script